import React from 'react';
import { PiArrowUpLight, PiArrowDownLight, PiMinusLight } from 'react-icons/pi';

interface MetricCardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    type: 'increase' | 'decrease' | 'neutral';
  };
  icon?: React.ReactNode;
  index?: number;
}

const MetricCard: React.FC<MetricCardProps> = ({ 
  title, 
  value, 
  change, 
  icon, 
  index = 0 
}) => {
  const getTrendIcon = () => {
    if (!change) return null;
    switch (change.type) {
      case 'increase':
        return <PiArrowUpLight className="w-5 h-5 text-gray-900" />;
      case 'decrease':
        return <PiArrowDownLight className="w-5 h-5 text-gray-500" />;
      default:
        return <PiMinusLight className="w-5 h-5 text-gray-400" />;
    }
  };

  const getTrendColor = () => {
    if (!change) return '';
    switch (change.type) {
      case 'increase':
        return 'text-gray-900';
      case 'decrease':
        return 'text-gray-500';
      default:
        return 'text-gray-400';
    }
  };

  return (
    <div 
      className="glass rounded-lg shadow-sm hover:shadow-md transition-all duration-300 p-6 group cursor-pointer animate-fade-in"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="flex items-center justify-between mb-4">
        {icon && (
          <div className="text-black">
            {icon}
          </div>
        )}
        {change && (
          <div className={`flex items-center gap-1 ${getTrendColor()}`}>
            {getTrendIcon()}
            <span className="text-sm">{change.value && `${Math.abs(change.value)} %`}</span>
          </div>
        )}
      </div>
      <div className="space-y-1">
        <h3 className="text-sm text-gray-600 dark:text-gray-400">{title}</h3>
        <div className="text-3xl text-gray-900 dark:text-gray-100 transition-colors duration-200">
          {value}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;